import Vue from 'vue';
import UsageTerms from '@/components/UsageTerms.vue';

export default Vue.extend({
  name: 'home',
  components: {
    'usage-terms': UsageTerms,
  },
  data: () => ({
    buttons: [
      {
        link: '/cadastrar-nota',
        image: require('@/assets/img/cadastrar-nota.png'),
      },
      {
        link: '/perfil',
        image: require('@/assets/img/perfil.png'),
      },
      {
        link: '/notas-enviadas',
        image: require('@/assets/img/notas-enviadas.png'),
      },
      {
        link: '/numeros-da-sorte',
        image: require('@/assets/img/numero-da-sorte.png'),
      },
    ],
  }),
  computed: {
    /**
     * Define que o componente de temros de uso possui o método open.
     * Necessário para as definições de tipos do TypeScript.
     */
    usageTerms(): Vue & { open: () => void } {
      return this.$refs.usageTerms as Vue & { open: () => void };
    },
    luckySpins(): number {
      return this.$store.getters.luckySpins;
    },
  },
  methods: {
    /**
     * Abre o dialog de Termos de Uso
     */
    openUsageTerms(): void {
      this.usageTerms.open();
    },
  },
  created(): void {
    //
  },
});
